module.exports = () ->
  return {
    restrict: 'A'
    template: require('./overlay-tagging-toolbar.html')
    scope:
      numberOfSelectedDocs: '&'
      allDocsSelected: '&'
      toggleSelectedDocs: '&'
      saveSelectedDocsTags: '&'
      isSidebarCollapsed: '&'

    controller: ($scope, $uibModal) ->
      $scope.annotation = null
      directiveScope = $scope

      $scope.applyDisposition = (selectedTagIds) ->
        if confirm("Are you sure you want to apply this disposition to the selected documents?")
          $scope.saveSelectedDocsTags({tagIdsToSave: selectedTagIds, annotation: $scope.annotation})

      $scope.openBulkAnnotationModal = ->
        $uibModal.open
          template: require('./bulk-annotation-modal.html')

          controller: ($scope, $uibModalInstance) ->
            $scope.numberOfSelectedDocs = directiveScope.numberOfSelectedDocs
            $scope.model = {
              annotation: directiveScope.annotation
            }

            $scope.close = ->
              $uibModalInstance.close()

            $scope.saveAnnotation = ->
              directiveScope.annotation = $scope.model.annotation
              $scope.close()


      $scope.$watch 'numberOfSelectedDocs()', (number) ->
        if number == 0
          $scope.annotation = null
  }
